"use client";

import type { TextColor } from "@homeinstead/schemas";
import type { Control } from "react-hook-form";
import type { FranchiseInquiryFormInput } from "./franchiseInquiry.schema";

import { IRL_COUNTIES } from "@homeinstead/locale";
import { FormError } from "@homeinstead/ui/components/FormError";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@homeinstead/ui/components/Select";
import { useId } from "react";
import { Controller } from "react-hook-form";
import { InquiryFieldLabel } from "~www/components/LeadForm/Inquiry";

type FranchiseInquiryCountySelectProps = {
  control: Control<FranchiseInquiryFormInput>;
  errorClassName?: string;
  errorMessage?: string;
  label: string;
  showError: boolean;
  textColor?: TextColor;
};

function FranchiseInquiryCountySelect({
  control,
  errorClassName,
  errorMessage,
  label,
  showError,
  textColor,
}: FranchiseInquiryCountySelectProps) {
  const fieldId = useId();

  return (
    <Controller
      control={control}
      name="county"
      render={({ field }) => (
        <div className="flex flex-col gap-2">
          <InquiryFieldLabel htmlFor={fieldId} textColor={textColor}>
            {label}
          </InquiryFieldLabel>
          <input name="county" type="hidden" value={field.value} />
          <Select onValueChange={field.onChange} value={field.value}>
            <SelectTrigger ariaLabel={label} id={fieldId}>
              <SelectValue placeholder="Select a county" />
            </SelectTrigger>
            <SelectContent>
              {IRL_COUNTIES.map((county) => (
                <SelectItem key={county} value={county}>
                  {county}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {showError ? (
            <FormError.span className={errorClassName}>
              {errorMessage}
            </FormError.span>
          ) : null}
        </div>
      )}
    />
  );
}

export { FranchiseInquiryCountySelect };
